import { DEFAULT_SEARCH_LOCATION } from '@/hooks/search/useSearch.constants';
import { _s } from '@/locale';
import { TabIdentifier, TabItem } from './MegaMenu.types';

const tBase = (key: string) => _s(`features.mega-menu.MegaMenu.constants.${key}`);

export const TAB_VISIBILITY_BREAKPOINT: {
  [key in TabIdentifier]?: number;
} = {
  [TabIdentifier.Wellnesscard]: 588,
  [TabIdentifier.Giftcard]: 393,
} as const;

const services: TabItem = {
  icon: 'menu',
  label: tBase('categories'),
  identifier: TabIdentifier.Categories,
  breakpoint: 'max-[768px]:inline-flex',
};

const hairdresser: TabItem = {
  icon: 'barber-scissors',
  label: tBase('hairdresser'),
  to: `/Frisör/${DEFAULT_SEARCH_LOCATION}`,
  identifier: TabIdentifier.Hairdresser,
  breakpoint: 'min-[768px]:inline-flex',
};

const massage: TabItem = {
  icon: 'massage',
  label: tBase('massage'),
  to: `/Massage/${DEFAULT_SEARCH_LOCATION}`,
  identifier: TabIdentifier.Massage,
  breakpoint: 'min-[768px]:inline-flex',
};

const nails: TabItem = {
  icon: 'nails',
  label: tBase('nails'),
  to: `/Naglar/${DEFAULT_SEARCH_LOCATION}`,
  identifier: TabIdentifier.Nails,
  breakpoint: 'min-[768px]:inline-flex',
};

const lashes: TabItem = {
  icon: 'lashes',
  label: tBase('lashes'),
  to: `/Fransar/${DEFAULT_SEARCH_LOCATION}`,
  identifier: TabIdentifier.Lashes,
  breakpoint: 'min-[912px]:inline-flex',
};

const skincare: TabItem = {
  icon: 'skincare',
  label: tBase('skincare'),
  to: `/Hudvård/${DEFAULT_SEARCH_LOCATION}`,
  identifier: TabIdentifier.Skincare,
  breakpoint: 'min-[1280px]:inline-flex',
};

const beauty: TabItem = {
  icon: 'beauty',
  label: tBase('beauty'),
  to: `/Skönhet/${DEFAULT_SEARCH_LOCATION}`,
  identifier: TabIdentifier.Beauty,
  breakpoint: 'min-[1280px]:inline-flex',
};

const health: TabItem = {
  icon: 'healthcare',
  label: tBase('health'),
  to: `/Hälsa/${DEFAULT_SEARCH_LOCATION}`,
  identifier: TabIdentifier.Health,
  breakpoint: 'min-[1280px]:inline-flex',
};

const more: TabItem = {
  icon: 'tags',
  label: tBase('more'),
  identifier: TabIdentifier.More,
  breakpoint: 'min-[768px]:inline-flex',
};

const wellnesscard: TabItem = {
  icon: 'wellness-card',
  label: tBase('wellnesscard'),
  identifier: TabIdentifier.Wellnesscard,
  /**
   * We cant use the constant here and interpolate the string since
   * it does not include that css in the built css file by tailwind
   *
   * update the constant if you change this breakpoint
   */
  breakpoint: 'min-[588px]:inline-flex',
};

const giftcard: TabItem = {
  icon: 'gift-card',
  label: tBase('giftcard'),
  identifier: TabIdentifier.Giftcard,
  /**
   * We cant use the constant here and interpolate the string since
   * it does not include that css in the built css file by tailwind
   *
   * update the constant if you change this breakpoint
   */
  breakpoint: 'min-[393px]:inline-flex',
};

const sistaMinuten: TabItem = {
  icon: 'smt-filled',
  label: tBase('smt'),
  identifier: TabIdentifier.SistaMinuten,
};

export const DEFAULT_TAB_ITEMS: TabItem[] = [
  services,
  hairdresser,
  massage,
  nails,
  lashes,
  skincare,
  beauty,
  health,
  more,
  giftcard,
  wellnesscard,
  sistaMinuten,
];
